/** Textes « flotte » — le français fait foi. */
export const flotte = {
  typeDoc: {
    assurance: 'Assurance', controle_technique: 'Contrôle technique', vignette: 'Vignette', carte_grise: 'Carte grise',
  } as Record<string, string>,
  archivee: 'Voiture archivée — elle sort du planning et des listes.',
  archivageEchec: "L'archivage n'a pas abouti.",
  enService: (v: string) => `${v} est de nouveau en service.`,
  remiseEchec: "La remise en service n'a pas abouti.",
  manque: {
    immatriculation: "l'immatriculation", marque: 'la marque', modele: 'le modèle',
    haute: 'le tarif été', basse: 'le tarif hiver',
  },
  ilManque: (n: number, liste: string) => `Il manque ${n > 1 ? 'encore ' : ''}${liste}.`,
  erreur: 'Erreur',
  depassee: (t: string) => `${t} · dépassée`,
  resteKm: (t: string, km: string, u: string) => `${t} · ${km} ${u}`,
  resteJours: (t: string, j: number) => `${t} · J-${j}`,
  docJours: (t: string, j: number) => `${t} · J-${j}`,
  titre: 'Mes voitures',
  sousTitreVide: 'Commencez par enregistrer vos voitures : tout le reste en depend',
  sousTitre: (n: number) => `${n} voiture${n > 1 ? 's' : ''} · chaque voiture a son propre tarif, été et hiver`,
  releverKm: 'Relever un kilométrage',
  retourService: '← Les voitures en service',
  archivees: 'Voitures archivées',
  ajouter: 'Ajouter une voiture',
  aucune: 'Aucune voiture enregistrée',
  ajouterPremiere: 'Ajouter ma première voiture',
  videTexte: "Chaque voiture porte son propre tarif — un tarif d'été et un tarif d'hiver — et ses dates d'assurance, de vignette et de contrôle technique. Le planning, les disponibilités et les contrats se remplissent ensuite tout seuls à partir d'ici.",
  demandezGerant: " Demandez à un gérant d'ajouter les voitures.",
  tarifEte: 'Tarif été',
  tarifHiver: 'Tarif hiver',
  kilometrage: 'Kilométrage',
  boite: 'Boîte',
  boites: { manuelle: 'manuelle', automatique: 'automatique' } as Record<string, string>,
  toucher: 'Toucher pour modifier ›',
  colonnes: { vehicule: 'Véhicule', immatriculation: 'Immatriculation', categorie: 'Catégorie', km: 'Km', documents: 'Documents', statut: 'Statut' },
  aJour: 'à jour',
  remettre: 'Remettre en service',
  modifier: 'Modifier',
  archiver: 'Archiver',
  note: "La colonne de la saison en cours est surlignée. Une voiture qui part avec une assurance expirée, c'est l'accident qui coûte à l'entreprise — d'où les alertes à 30, 15 et 7 jours.",
  chercherDispo: 'Chercher une disponibilité',
  archiverTitre: (v: string) => `Archiver ${v}`,
  archiverBandeauTitre: 'La voiture sort du travail courant',
  archiverBandeau: 'Elle disparaît du planning, des disponibilités et des échéances. Son historique — contrats, entretiens, amendes — reste consultable, et vous pouvez la remettre en service à tout moment.',
  motif: 'Motif (obligatoire)',
  motifAide: 'Vendue, accidentée, rendue au propriétaire…',
  annuler: 'Annuler',
  modifierTitre: (v: string) => `Modifier ${v}`,
  immatriculation: 'Immatriculation',
  immatriculationAide: 'Format algérien à 6 chiffres : 045218-116-16',
  marque: 'Marque *',
  modele: 'Modèle *',
  annee: 'Année',
  categorie: 'Catégorie',
  categories: {
    'A — Citadine': 'A — Citadine', 'B — Économique': 'B — Économique', 'C — Compacte': 'C — Compacte',
    'D — Berline': 'D — Berline', 'E — SUV': 'E — SUV', 'U — Utilitaire': 'U — Utilitaire',
  } as Record<string, string>,
  manuelle: 'Manuelle',
  automatique: 'Automatique',
  carburant: 'Carburant',
  carburants: { essence: 'essence', diesel: 'diesel', gpl: 'gpl', hybride: 'hybride' } as Record<string, string>,
  tarifHaute: (d: string) => `Tarif haute saison (${d} / jour)`,
  tarifHauteAide: "L'ete.",
  tarifBasse: (d: string) => `Tarif hiver (${d} / jour) *`,
  obligatoire: 'Obligatoire.',
  tarifMois: (d: string) => `Tarif au mois (${d})`,
  tarifMoisAide: 'Facultatif — un prix fixe par mois, que le mois fasse 28 ou 31 jours.',
  kmActuel: 'Kilométrage actuel',
  tarifSuspect: (prix: string) =>
    `Un tarif de ${prix} par jour est très bas : chaque location, chaque encaissement et la caisse `
    + "seront calculés sur ce montant. S'il se négocie à chaque location, mettez votre prix habituel ici.",
  kmAZero: "Le compteur est à 0 : les vidanges et le kilométrage du retour se calculent à partir de lui. "
    + 'Saisissez le kilométrage réel.',
  forfait: (u: string) => `Forfait ${u} / jour`,
  forfaitAide: '0 = illimite. Article 05 : 250 par defaut.',
  assuranceExpire: 'Assurance expire le',
  controle: 'Contrôle technique',
  vignette: 'Vignette',
  boitier: 'Identifiant du boîtier GPS',
  boitierAide: 'A remplir le jour ou vous equiperez la flotte. Laisse vide, il ne sert a rien.',
  enregistrer: 'Enregistrer',
  ajouterVoiture: 'Ajouter la voiture',
};
